@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';

.loading {
  margin: auto;
  height: 36px;
}

.last-modified,
.last-modified-head {
  display: flex;
}

.actions {
  > button {
    padding-right: 10px;
  }
}

.menu-toggle {
  height: 32px;
  width: 32px;
  border-radius: 6px;
  color: @settings-page--shipping-carriers-list-menu--text-color;

  &:hover,
  &:focus {
    background-color: @settings-page--shipping-carriers-list-menu--hover--background-color;
    color: @settings-page--shipping-carriers-list-menu--hover--text-color;
  }

  &:active {
    background-color: @settings-page--shipping-carriers-list-menu--active--background-color;
    color: @settings-page--shipping-carriers-list-menu--active--text-color;
  }
}

.open-menu-toggle {
  background-color: @settings-page--shipping-carriers-list-open-menu--background-color;
  color: @settings-page--shipping-carriers-list-open-menu--text-color;
}

.menu-toggle-contents {
  display: flex;
  align-items: center;
  justify-content: center;

  & > svg {
    width: 16px;
  }
}
